import React from 'react';

const Newsletter = () => {
  return (
    <section className="py-5 d-none d-md-flex">
      <div className="container">
        <div className="row align-items-center g-4">
          {/* Left Text Section */}
          <div className="col-md-6 text-md-start text-center">
            <h2 className="fw-bold mb-2">
              Stay in the Loop!
            </h2>
            <p className="text-muted mb-0">
              Subscribe to get the latest travel deals, updates, and offers from ZoyoTrip.
            </p>
          </div>

          {/* Right Form Section */}
          <div className="col-md-6">
            <form className="d-flex flex-column flex-sm-row align-items-stretch gap-2">
              <input
                type="email"
                className="form-control form-control-lg rounded-pill px-4"
                placeholder="Enter your email address"
                required
              />
              <button type="submit" className="btn btn-primary btn-lg rounded-pill px-4 fw-semibold">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Optional Custom Scroll Hide (for mobile if needed) */}
      <style>
        {`
          @media (max-width: 576px) {
            .form-control::placeholder {
              font-size: 14px;
            }
          }
        `}
      </style>
    </section>
  );
};

export default Newsletter;
